import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@sama/app-state';
import { PointCloudToolName } from '../../state/point-cloud-content-state';
import { AbstractMainToolbar3DComponent } from '../abstract-main-toolbar/abstract-main-toolbar-3d.component';
import { makeTooltipProvider } from '../toolbar-utils';

@Component({
  selector: 'h3-main-point-cloud-toolbar-objectless',
  templateUrl:
    '../abstract-main-toolbar/abstract-main-toolbar-3d.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [makeTooltipProvider('right')],
  standalone: false,
})
export class MainPointCloudToolbarComponent extends AbstractMainToolbar3DComponent {
  override getSelectedToolStore(): Store<PointCloudToolName> {
    return this.store('selectedTool');
  }
}
